import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]

import { ref, onMounted } from 'vue'
import { useRtfix } from '@/store'
import { useStore } from 'vuex'
import { memberChangeZeroFlag, UpmemberChangeZeroFlag } from '@/apis/membership'
import { useRouter } from 'vue-router'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const membership = store.getters.membership
const authShopVisible = ref(false)

onMounted(() => {
  getMemberChangeZeroFlag()
})

const getMemberChangeZeroFlag = () => {
  memberChangeZeroFlag().then((res: any) => {
    if (membership.templateLevel === 0) {
      if (res.data === false) {
        authShopVisible.value = true
      }
    }
  })
}
const closeModal = (type:any) => {
  UpmemberChangeZeroFlag().then((res: any) => {
    authShopVisible.value = false
    if (type === 2) router.push(useRtfix('VipLevel'))
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: authShopVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((authShopVisible).value = $event)),
      width: "550px",
      center: "",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "custom-class": "syncOrderVisible",
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: closeModal,
          type: "default"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('我知道了')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal(2))),
          type: "primary",
          class: "ml_20"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('办理会员')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('授权店铺API绑定变更')), 1),
          _createElementVNode("span", {
            innerHTML: _unref(t)('尊敬的用户，您于T变更为非会员用户，已授权店铺绑定的API变更为禁用状态（不影响历史订单及账户余额提现）')
        .replace('T', `<span style='color:#eb4545'>${_unref(membership).updateTime}</span>`)
          }, null, 8, _hoisted_3)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})